import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import { BsBookmarkPlus } from 'react-icons/bs';

const EmptyLibraryContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem 2rem 1rem;
  color: #888;
  text-align: center;
`;

const EmptyLibraryIcon = styled(BsBookmarkPlus)`
  font-size: 2.5rem;
  color: #bcbcbc;
  margin-bottom: 0.5rem;
`;

const EmptyLibraryTitle = styled.div`
  font-size: 1.15rem;
  font-weight: 600;
  color: #444;
  margin-bottom: 0.5rem;
`;

const EmptyLibraryInstruction = styled.div`
  font-size: 0.95rem;
  color: #666;
  margin-bottom: 0.5rem;
`;

const StyledLink = styled(Link)`
  color: #8e3dff;
  text-decoration: underline;
  font-weight: 500;
  &:hover {
    color: #5f1bbd;
    text-decoration: underline;
  }
`;

const WordListPlaceholder = () => (
  <Card style={{ border: '1px solid #dee2e6' }}>
    <Card.Body>
      <EmptyLibraryContainer>
        <EmptyLibraryIcon />
        <EmptyLibraryTitle>No words yet</EmptyLibraryTitle>
        <EmptyLibraryInstruction>Try searching for a word above.</EmptyLibraryInstruction>
      </EmptyLibraryContainer>
    </Card.Body>
  </Card>
);

export default WordListPlaceholder;
